import { combineReducers } from 'redux';
import { RootAction } from '../types';

const uploadID = (f: File) => `${f.name}-${f.lastModified}-${f.size}`;

export type UploadState =
    'waiting' |
    'uploading' |
    'failed' |
    'done';

export interface IUploadData {
    id: string,
    file: File,
    state: UploadState,
    error: Error | null,
}

export function data(state: {[k: string]: IUploadData} = {}, action: RootAction): {[k: string]: IUploadData} {
    let id: string;

    switch (action.type) {
    case 'ADD_UPLOADS':
        const newState = {...state};
        action.payload.forEach(file => {
            id = uploadID(file);
            newState[id] = {
                error: null,
                file,
                id,
                state: 'waiting',
            };
        });
        return newState;
    
    case 'DO_UPLOAD_SUCCESS':
        id = action.meta.id;
        return {
            ...state,
            [id]: {
                ...state[id],
                error: null,
                state: 'done',
            }
        };

    case 'DO_UPLOAD_FAILURE':
        id = action.meta.id;
        return {
            ...state,
            [id]: {
                ...state[id],
                error: action.payload,
                state: 'failed',
            }
        };
        
    case 'DO_UPLOAD_REQUEST':
        id = action.meta.id;
        return {
            ...state,
            [id]: {
                ...state[id],
                error: null,
                state: 'uploading',
            }
        };

    default:
        return state;
    }
}

export function queue(state: string[] = [], action: RootAction): string[] {
    switch (action.type) {
    case 'ADD_UPLOADS':
        const ids = action.payload.map(f => uploadID(f));
        const newIDs = ids.filter(i => state.indexOf(i) === -1);
        return [...state].concat(newIDs);
    default:
        return state;
    }
}

export const uploadsReducer = combineReducers({
    data,
    queue,
});

export default uploadsReducer;



// WEBPACK FOOTER //
// ./src/reducers/uploadsReducer.ts